import React, { useState, useEffect } from 'react';
import VdoPlayer from '../Lesson/VdoPlayer.tsx';
import { Grid, Button } from '@radix-ui/themes';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api/axios.js';

const ManageLesson = () => {
    const navigate = useNavigate();
    const [lessons, setLessons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [draggedItem, setDraggedItem] = useState(null);

    useEffect(() => {
        fetchLessons();
    }, []);

    const fetchLessons = async () => {
        try {
            const response = await api.get(`/allLessons`);
            const sortedLessons = response.data.sort((a, b) => {
                if (a.order !== undefined && b.order !== undefined) {
                    return a.order - b.order;
                }
                return a.id - b.id;
            });
            setLessons(sortedLessons);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching lessons:', err);
            setError('Failed to load lessons');
            setLoading(false);
        }
    };

    const handleLessonClick = (lessonId) => {
        navigate(`/backend/lesson/${lessonId}`);
    };

    const handleDeleteVideo = async (lessonId) => {
        if (!window.confirm('Are you sure you want to delete this video?')) {
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/lessons/${lessonId}/video`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to delete video');
            }

            fetchLessons();
        } catch (error) {
            console.error('Error deleting video:', error);
            alert('Failed to delete video');
        }
    };

    const handleDragStart = (e, lesson) => {
        setDraggedItem(lesson);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', lesson.id);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    const handleDrop = async (e, targetLesson) => {
        e.preventDefault();
        if (!draggedItem || draggedItem.id === targetLesson.id) return;

        const items = [...lessons];
        const draggedIndex = items.findIndex(item => item.id === draggedItem.id);
        const targetIndex = items.findIndex(item => item.id === targetLesson.id);

        items.splice(draggedIndex, 1);
        items.splice(targetIndex, 0, draggedItem);

        try {
            await api.put(`/lessons/order`, {
                lessons: items.map((lesson, index) => ({
                    id: lesson.id,
                    order: index
                }))
            });
            
            setLessons(items);
        } catch (error) {
            console.error('Error updating lesson order:', error);
            alert('Failed to update lesson order');
        }

        setDraggedItem(null);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div id="lesson-list" style={{ padding: '20px 100px' }}>
            <div className="lesson-list-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>จัดการบทเรียน</h1>
                <Button onClick={() => navigate('/backend/uploadVdo')} style={{ cursor: 'pointer' }}>เพิ่มบทเรียน</Button>
            </div>
            <Grid columns="4" gap="5">
                {lessons.map((lesson) => (
                    <div 
                        key={lesson.id}
                        className='lesson-list-item'
                        style={{ 
                            cursor: 'pointer',
                            opacity: draggedItem?.id === lesson.id ? 0.5 : 1,
                            transition: 'opacity 0.2s'
                        }}
                        draggable
                        onDragStart={(e) => handleDragStart(e, lesson)}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, lesson)}
                    >
                        <VdoPlayer videoUrl={lesson.vdo_file} />
                        <div 
                            className="lesson-list-content" 
                            style={{ textAlign: 'left', minHeight: '50px' }}
                            onClick={() => handleLessonClick(lesson.id)}
                        >
                            <h3 style={{ fontWeight: 'bold' }}>{lesson.name}</h3>
                            <p>{lesson.description}</p>
                        </div>
                        {lesson.vdo_file && (
                            <button 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteVideo(lesson.id);
                                }}
                                className="btn btn-danger btn-sm"
                                style={{ 
                                    fontSize: '0.75rem',
                                    padding: '2px 8px',
                                    backgroundColor: '#dc3545',
                                    borderColor: '#dc3545',
                                    color: 'white',
                                    margin: '8px 0'
                                }}
                            >
                                Delete
                            </button>
                        )}
                    </div>
                ))}
            </Grid>
        </div>
    );
};

export default ManageLesson;